import vue from 'vue'
import share from '$components/bv-bind-phone/bv-bind-phone-share.vue'
const shareConstructor =  vue.extend(share);
function showModal(text){
    const shareDom = new shareConstructor({
        el : document.createElement('div'),
        data(){
            return {
               show:true
            }
        }
    });
    document.body.appendChild(shareDom.$el)
}

function registryShareModal (){
    vue.prototype.$shareModal = showModal;
}
export default registryShareModal 